import { getSiloV3MarketEntry } from '@1delta/data-sdk'
import { SiloAbi } from '../../../abis/silo-v2/Silo'
import { InterestRateModelV2Abi } from '../../../abis/silo-v2/InterestRateModelV2'

/**
 * Silo v3 on-chain public-data call builder.
 *
 * Mirror of `silo-v2/publicCallBuild.ts`. v3 reuses the v2 on-chain ABI
 * (`Silo.sol` → `totalAssets()` / `getDebtAssets()`) and IRM shape
 * (`InterestRateModelV2.getConfig(silo)`). The only difference is the
 * registry getter (`getSiloV3MarketEntry`).
 *
 * Per Silo v3 pair we emit 6 multicall entries (3 per side):
 *   silo0.totalAssets()
 *   silo0.getDebtAssets()
 *   irm0.getConfig(silo0)
 *   silo1.totalAssets()
 *   silo1.getDebtAssets()
 *   irm1.getConfig(silo1)
 *
 * Rates are derived in the parser from the IRM config + current utilization.
 */
export const SILO_V3_CALLS_PER_SIDE = 3
export const SILO_V3_CALLS_PER_PAIR = SILO_V3_CALLS_PER_SIDE * 2

export function buildSiloV3LenderReserveCall(
  _chainId: string,
  lender: string,
) {
  const market = getSiloV3MarketEntry(_chainId, lender)
  if (!market) return []

  const calls: any[] = []
  for (const half of [market.silo0, market.silo1]) {
    calls.push(
      {
        address: half.silo,
        name: 'totalAssets',
        params: [],
        abi: SiloAbi,
      },
      {
        address: half.silo,
        name: 'getDebtAssets',
        params: [],
        abi: SiloAbi,
      },
      {
        address: half.interestRateModel,
        name: 'getConfig',
        params: [half.silo],
        abi: InterestRateModelV2Abi,
      },
    )
  }
  return calls
}
